import React, { FC, useEffect } from 'react';
import styles from './index.module.less';
import cls from 'classnames';
import { toggleGlobalScroll } from '@/utils';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  visible: boolean;
}

const Curtain: FC<Props> = ({ visible, ...rest }) => {
  useEffect(() => {
    toggleGlobalScroll(visible);
  }, [visible]);

  return (
    <div
      className={cls({
        [styles.mask]: true,
        [styles.visible]: visible,
      })}
      {...rest}
    ></div>
  );
};

export default Curtain;
